export const token_addresses = {
  customTokenAddress:"0x30426D33a78afdb8788597D5BFaBdADc3Be95698",
  composerAddress:"0x53CA7a8cba6d06D8B6623331AB564d03a036CC09",
  registryAddress:"0xB2c9e8ae6DC7A856102cE9807Db4A175087C7A90"
}
